import { createContext } from 'react';

export type Theme = 'light' | 'dark' | 'system';

export interface ThemeContextValue {
  readonly theme: Theme;
  readonly setTheme: (theme: Theme) => void;
}

/**
 * Contexto del tema.
 *
 * Vive separado del provider para que el modulo del provider exporte solo
 * componentes: es lo que permite a Fast Refresh recargar la interfaz sin
 * perder el estado durante el desarrollo.
 */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
